import axios from 'axios';
import React, { useEffect, useState } from 'react';
import { FiBarChart, FiBriefcase, FiDollarSign, FiEye, FiFilter, FiFlag, FiPaperclip, FiPlus, FiUserCheck, FiUserMinus, FiUsers } from 'react-icons/fi'
import { BsFiletypeCsv, BsFiletypeExe, BsFiletypePdf, BsFiletypeTsx, BsFiletypeXml, BsPrinter } from 'react-icons/bs';
import Dropdown from '../shared/Dropdown';
import LeadsStatisticsTwo from "../widgetsStatistics/LeadsStatisticsTwo"
import useTranslations from "../../hooks/useTranslations";
import useUserLanguage from "../../hooks/useUserLanguage";
import { useParams, Link } from "react-router-dom";


const filterAction = [
    { label: "All", icon: <FiEye /> },
    { label: "Group", icon: <FiUsers /> },
    { label: "Country", icon: <FiFlag /> },
    { label: "Invoice", icon: <FiDollarSign /> },
    { label: "Project", icon: <FiBriefcase /> },
    { label: "Active", icon: <FiUserCheck /> },
    { label: "Inactive", icon: <FiUserMinus /> },
];
export const fileType = [
    { label: "PDF", icon: <BsFiletypePdf /> },
    { label: "CSV", icon: <BsFiletypeCsv /> },
    { label: "XML", icon: <BsFiletypeXml /> },
    { label: "Text", icon: <BsFiletypeTsx /> },
    { label: "Excel", icon: <BsFiletypeExe /> },
    { label: "Print", icon: <BsPrinter /> },
];

const LeadsHeader = () => {
    const { slug } = useParams();

    const [myPermissions, setMyPermissions] = useState([]);
// Kullanıcının dilini al ve çevirileri getir
const userLanguage = useUserLanguage();
const { translations: trans } = useTranslations(userLanguage);
const getText = (key, defaultValue) => trans[key] || defaultValue;
    // 1) Komponent açılırken kullanıcının permissions verisini çek
    useEffect(() => {
      fetchMyPermissions();
    }, []);
  
    const fetchMyPermissions = async () => {
      try {
        const token = localStorage.getItem("admin_token");
        const resp = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/admin/my-permissions`, {
          headers: { Authorization: `Bearer ${token}` },
        });
    
        //  Eğer API boş dönerse veya yanlış formatta dönerse, boş array ata.
        if (!resp.data || !Array.isArray(resp.data.permissions)) {
          console.error("⚠️ API yanlış veri döndürdü:", resp.data);
          setMyPermissions([]); // 🔥 Hata varsa boş array olarak set et
        } else {
          setMyPermissions(resp.data.permissions);
        }
      } catch (error) {
        console.error("❌ Permission bilgileri çekilemedi:", error);
        setMyPermissions([]); // Hata alındığında boş array ata
      }
    };
    
  
    // 2) “Yönetici Hesapları” modülünün izni
    const adminModulePerm = myPermissions.find(p => p.module_key === "static_admin_account");
    // 3) create_permission veya full_access varsa butonu göstermek
    const canCreate = adminModulePerm?.create_permission || adminModulePerm?.full_access;

    return (
        <>
            <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
       
       
           <Link to={`/skills/create`} className="btn btn-primary">
           <FiPlus size={16} className="me-2" />
           <span>{getText("ROLE_CREATE_TITLE")}</span>
         </Link>
        
      </div>

            <div id="collapseOne" className="accordion-collapse collapse page-header-collapse">
                <div className="accordion-body pb-2">
                    <div className="row">
                        <LeadsStatisticsTwo />
                    </div>
                </div>
            </div>
        </>
    )
}

export default LeadsHeader